import http from 'hub-http/clients/apiClient';
import { logRavenException } from '../../utils/errors';
let _cachedProducts;
export const resetProductCache = () => {
  _cachedProducts = null;
};
export const getProducts = () => {
  if (_cachedProducts) {
    return _cachedProducts;
  }
  _cachedProducts = http.get('monetization/v3/product/in-app').catch(error => {
    resetProductCache();
    if (error && error.status === 0) {
      return;
    }
    logRavenException({
      customMessage: 'Failed to fetch products',
      error,
      fingerprint: ['getProducts']
    });
  });
  return _cachedProducts;
};